import React, { useState, useEffect } from "react";
import axios from "axios";

const UpdateRequest = ({ onClose }) => {
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [newPrice, setNewPrice] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const token = localStorage.getItem("token");
  const [currentPrice, setCurrentPrice] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchData = async (url) => {
    try {
      const { data } = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    } catch (error) {
      console.error(`Error fetching from ${url}:`, error);
      setMessage(`Failed to load data from ${url}`);
      setMessageType("error");
      throw error;
    }
  };

  const fetchServices = async () => {
    const data = await fetchData(
      "https://genz-staging.feeltiptop.com/api/payment/get-service-requests",
    );
    console.log("Data table: ", data);
    setServices(data);
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      await fetchServices();
      setLoading(false);
    };
    loadData();
  }, [token]);

  const handleUpdatePrice = async (e) => {
    e.preventDefault();

    const priceToSend = parseFloat(newPrice);
    const priceDifference = priceToSend - currentPrice;

    if (isNaN(priceToSend) || priceToSend <= 0) {
      setMessage("Please enter a valid price.");
      setMessageType("error");
      return;
    }

    if (priceToSend <= currentPrice) {
      setMessage("New price must be higher than the current price.");
      setMessageType("error");
      return;
    }

    try {
      const sessionResponse = await axios.post(
        "https://genz-staging.feeltiptop.com/api/payment/update-price",
        {
          price: priceDifference,
          requestID: selectedService,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setMessage(sessionResponse.data.message);
      setMessageType(
        sessionResponse.data.message === "Price updated successfully."
          ? "success"
          : "error",
      );

      if (sessionResponse.data.message === "Price updated successfully.") {
        await fetchServices();
        setSelectedService("");
        setNewPrice("");
        setCurrentPrice(0);
      }
    } catch (error) {
      setMessage("Failed to update price. Please try again later.");
      setMessageType("error");
    }
  };

  const handleServiceSelection = (e) => {
    const selectedId = e.target.value;
    setSelectedService(selectedId);
    setNewPrice("");

    const selected = services.find(
      (service) => service.requestID.toString() === selectedId,
    );
    setCurrentPrice(selected ? parseFloat(selected.price) : 0);
  };

  const isButtonDisabled =
    !selectedService ||
    !newPrice ||
    isNaN(newPrice) ||
    parseFloat(newPrice) <= 0;

  return (
    <div className="relative w-[500px] rounded-lg bg-white p-3 shadow-lg">
      <button
        onClick={onClose}
        className="absolute right-5 top-5 rounded-lg px-3 py-2 text-right font-semibold shadow-sm"
      >
        X
      </button>
      <h2 className="mb-1 text-left text-lg font-normal text-gray-800">
        Update Service Price
      </h2>
      <p className="mb-6 text-left text-sm text-gray-500">
        Edit the price of your listed service
      </p>

      {message && (
        <div
          className={`mb-4 rounded-lg p-4 ${
            messageType === "success"
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleUpdatePrice} className="m-0 space-y-5">
        <select
          value={selectedService}
          onChange={handleServiceSelection}
          className="w-full rounded-2xl border border-gray-500 bg-white p-2 text-gray-900"
        >
          <option value="">Select a service</option>
          {services.map((service) => (
            <option key={service.requestID} value={service.requestID}>
              {service.title} - {service.price}
            </option>
          ))}
        </select>

        <div className="flex gap-4">
          <input
            type="number"
            placeholder="New Price"
            value={newPrice}
            onChange={(e) => setNewPrice(e.target.value)}
            className="w-2/3 rounded-2xl border border-gray-300 bg-white p-2 text-gray-900"
            min="1"
            step="1"
          />
          <button
            type="submit"
            className={`w-1/3 rounded-2xl p-2 font-medium transition-colors duration-200 ${
              isButtonDisabled
                ? "cursor-not-allowed bg-gray-400 text-gray-100"
                : "bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800"
            }`}
            disabled={isButtonDisabled}
          >
            Update
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateRequest;
